var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{mix-blend-mode:multiply;}.cls-3{fill:#5ecc44;}.cls-4{fill:#4aa82f;}.cls-5{fill:#ea5036;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "snake") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103,97a8,8,0,0,1-8,8H39a8,8,0,1,1,0-16H95A8,8,0,0,1,103,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.32,72.24A8,8,0,0,0,77,61H57a8,8,0,0,0-7.32,11.24A2,2,0,0,1,47.84,75H86.16A2,2,0,0,1,84.32,72.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.32,86.24A8,8,0,0,0,86,75H48a8,8,0,0,0-7.32,11.24A2,2,0,0,1,38.84,89H95.16A2,2,0,0,1,93.32,86.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.75,27.63A30.9,30.9,0,0,0,71,23,11.77,11.77,0,0,0,59,35V61H71V42a2,2,0,0,1,2-2c7.25.5,8.75-2.44,14.63-1.19,5.09,1.08,5.9-1.47,5.81-3.56C93.31,32.31,90.31,29.7,86.75,27.63Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 31,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.59,105H38.5c-6.23,0-11-2.32-13.59-6.53-3.12-5.17-2.37-12.7,2.11-21.2a.5.5,0,0,1,.39-.27.49.49,0,0,1,.43.18c1.24,1.44,1,3.91.72,6.51-.31,3.06-.66,6.52,1.34,8.74a6,6,0,0,0,1.79,1.34A7.77,7.77,0,0,0,31,97,8,8,0,0,0,38.59,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.37,35.93l-2.58,1.63,1.92,2.73a1,1,0,0,1-.25,1.42,1,1,0,0,1-1.17,0L99,39.39a4.21,4.21,0,0,0-1.56-.65l-4.64-.87a4.06,4.06,0,0,0,.65-2.62,4.41,4.41,0,0,0-.28-1.38l5.16,1a4.09,4.09,0,0,0,1.52,0l3.79-.76a1,1,0,0,1,.74,1.86Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnake);
export default __webpack_public_path__ + "static/media/snake.21157607f9523d4fbf82fd13d85135f9.svg";
export { ForwardRef as ReactComponent };